module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/inmuebles24_mobile.35566006.svg";